import navigation from "@/lang/zh_CN/navigation";
import generics from "@/lang/zh_CN/generics";
import questions from "@/lang/zh_CN/questions";
import a11y from "@/lang/zh_CN/a11y";
import velt from "@/lang/zh_CN/velt";

export default {
  ...navigation,
  ...generics,
  ...questions,
  ...a11y,
  ...velt
}
